import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IUmbClasseState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const umbClasseModule: Module<IUmbClasseState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default umbClasseModule
